import { useState, useEffect } from 'react';
import { type LanguageCode, getLanguageFromPath, detectBrowserLanguage, defaultLanguage } from './i18n';

// Importa todos os arquivos de tradução
import ptBR from '../locales/pt-BR/index.json';
import ptBRTerms from '../locales/pt-BR/terms.json';
import ptBRFaq from '../locales/pt-BR/faq.json';
import ptBRPrivacy from '../locales/pt-BR/privacy.json';
import ptBRAuth from '../locales/pt-BR/auth.json';
import ptBRThemes from '../locales/pt-BR/themes.json';
import ptBRWishlist from '../locales/pt-BR/wishlist.json';
import ptBRAI from '../locales/pt-BR/ai.json';
import ptBRMessages from '../locales/pt-BR/messages.json';
import ptBRBlogPost1 from '../locales/pt-BR/blogpost1.json';
import ptBRBlogPost2 from '../locales/pt-BR/blogpost2.json';
import ptBRBlogPost3 from '../locales/pt-BR/blogpost3.json';
import ptBRBlogPost4 from '../locales/pt-BR/blogpost4.json';
import ptBRBlogPost5 from '../locales/pt-BR/blogpost5.json';
import ptBRBlogPost6 from '../locales/pt-BR/blogpost6.json';
import ptBRDraw from '../locales/pt-BR/draw.json';
import ptBRAbout from '../locales/pt-BR/about.json';
import ptBRAISuggestions from '../locales/pt-BR/ai-suggestions.json';
import ptBRAccountDeletion from '../locales/pt-BR/account-deletion.json';

import enUS from '../locales/en-US/index.json';
import enUSTerms from '../locales/en-US/terms.json';
import enUSFaq from '../locales/en-US/faq.json';
import enUSPrivacy from '../locales/en-US/privacy.json';
import enUSAuth from '../locales/en-US/auth.json';
import enUSThemes from '../locales/en-US/themes.json';
import enUSWishlist from '../locales/en-US/wishlist.json';
import enUSAI from '../locales/en-US/ai.json';
import enUSMessages from '../locales/en-US/messages.json';
import enUSBlogPost1 from '../locales/en-US/blogpost1.json';
import enUSBlogPost2 from '../locales/en-US/blogpost2.json';
import enUSBlogPost3 from '../locales/en-US/blogpost3.json';
import enUSBlogPost4 from '../locales/en-US/blogpost4.json';
import enUSBlogPost5 from '../locales/en-US/blogpost5.json';
import enUSBlogPost6 from '../locales/en-US/blogpost6.json';
import enUSDraw from '../locales/en-US/draw.json';
import enUSAbout from '../locales/en-US/about.json';
import enUSAISuggestions from '../locales/en-US/ai-suggestions.json';
import enUSAccountDeletion from '../locales/en-US/account-deletion.json';

import esES from '../locales/es-ES/index.json';
import esESTerms from '../locales/es-ES/terms.json';
import esESFaq from '../locales/es-ES/faq.json';
import esESPrivacy from '../locales/es-ES/privacy.json';
import esESAuth from '../locales/es-ES/auth.json';
import esESThemes from '../locales/es-ES/themes.json';
import esESWishlist from '../locales/es-ES/wishlist.json';
import esESAIFeature from '../locales/es-ES/ai.json';
import esESMessagesFeature from '../locales/es-ES/messages.json';
import esESBlogPost1 from '../locales/es-ES/blogpost1.json';
import esESBlogPost2 from '../locales/es-ES/blogpost2.json';
import esESBlogPost3 from '../locales/es-ES/blogpost3.json';
import esESBlogPost4 from '../locales/es-ES/blogpost4.json';
import esESBlogPost5 from '../locales/es-ES/blogpost5.json';
import esESBlogPost6 from '../locales/es-ES/blogpost6.json';
import esESDrawFeature from '../locales/es-ES/draw.json';
import esESAbout from '../locales/es-ES/about.json';
import esESAISuggestions from '../locales/es-ES/ai-suggestions.json';
import esESAccountDeletion from '../locales/es-ES/account-deletion.json';

import frFR from '../locales/fr-FR/index.json';
import frFRTerms from '../locales/fr-FR/terms.json';
import frFRFaq from '../locales/fr-FR/faq.json';
import frFRPrivacy from '../locales/fr-FR/privacy.json';
import frFRAuth from '../locales/fr-FR/auth.json';
import frFRTopics from '../locales/fr-FR/themes.json';
import frFRWishlist from '../locales/fr-FR/wishlist.json';
import frFRAI from '../locales/fr-FR/ai.json';
import frFRMessages from '../locales/fr-FR/messages.json';
import frFRBlogPost1 from '../locales/fr-FR/blogpost1.json';
import frFRBlogPost2 from '../locales/fr-FR/blogpost2.json';
import frFRBlogPost3 from '../locales/fr-FR/blogpost3.json';
import frFRBlogPost4 from '../locales/fr-FR/blogpost4.json';
import frFRBlogPost5 from '../locales/fr-FR/blogpost5.json';
import frFRBlogPost6 from '../locales/fr-FR/blogpost6.json';
import frFRDraw from '../locales/fr-FR/draw.json';
import frFRAbout from '../locales/fr-FR/about.json';
import frFRAISuggestions from '../locales/fr-FR/ai-suggestions.json';
import frFRAccountDeletion from '../locales/fr-FR/account-deletion.json';

import deDE from '../locales/de-DE/index.json';
import deDETerms from '../locales/de-DE/terms.json';
import deDEFaq from '../locales/de-DE/faq.json';
import deDEPrivacy from '../locales/de-DE/privacy.json';
import deDEAuth from '../locales/de-DE/auth.json';
import deDETopics from '../locales/de-DE/themes.json';
import deDEWishlist from '../locales/de-DE/wishlist.json';
import deDEAI from '../locales/de-DE/ai.json';
import deDEMessages from '../locales/de-DE/messages.json';
import deDEBlogPost1 from '../locales/de-DE/blogpost1.json';
import deDEBlogPost2 from '../locales/de-DE/blogpost2.json';
import deDEBlogPost3 from '../locales/de-DE/blogpost3.json';
import deDEBlogPost4 from '../locales/de-DE/blogpost4.json';
import deDEBlogPost5 from '../locales/de-DE/blogpost5.json';
import deDEBlogPost6 from '../locales/de-DE/blogpost6.json';
import deDEDraw from '../locales/de-DE/draw.json';
import deDEAbout from '../locales/de-DE/about.json';
import deDEAISuggestions from '../locales/de-DE/ai-suggestions.json';
import deDEAccountDeletion from '../locales/de-DE/account-deletion.json';

import itIT from '../locales/it-IT/index.json';
import itITTerms from '../locales/it-IT/terms.json';
import itITFaq from '../locales/it-IT/faq.json';
import itITPrivacy from '../locales/it-IT/privacy.json';
import itITAuth from '../locales/it-IT/auth.json';
import itITTopics from '../locales/it-IT/themes.json';
import itITWishlist from '../locales/it-IT/wishlist.json';
import itITAIFeature from '../locales/it-IT/ai.json';
import itITMessagesFeature from '../locales/it-IT/messages.json';
import itITBlogPost1 from '../locales/it-IT/blogpost1.json';
import itITBlogPost2 from '../locales/it-IT/blogpost2.json';
import itITBlogPost3 from '../locales/it-IT/blogpost3.json';
import itITBlogPost4 from '../locales/it-IT/blogpost4.json';
import itITBlogPost5 from '../locales/it-IT/blogpost5.json';
import itITBlogPost6 from '../locales/it-IT/blogpost6.json';
import itITDrawFeature from '../locales/it-IT/draw.json';
import itITAbout from '../locales/it-IT/about.json';
import itITAISuggestions from '../locales/it-IT/ai-suggestions.json';
import itITAccountDeletion from '../locales/it-IT/account-deletion.json';

import jaJP from '../locales/ja-JP/index.json';
import jaJPTerms from '../locales/ja-JP/terms.json';
import jaJPFaq from '../locales/ja-JP/faq.json';
import jaJPPrivacy from '../locales/ja-JP/privacy.json';
import jaJPAuth from '../locales/ja-JP/auth.json';
import jaJPTopics from '../locales/ja-JP/themes.json';
import jaJPWishlist from '../locales/ja-JP/wishlist.json';
import jaJPAIFeature from '../locales/ja-JP/ai.json';
import jaJPMessagesFeature from '../locales/ja-JP/messages.json';
import jaJPBlogPost1 from '../locales/ja-JP/blogpost1.json';
import jaJPBlogPost2 from '../locales/ja-JP/blogpost2.json';
import jaJPBlogPost3 from '../locales/ja-JP/blogpost3.json';
import jaJPBlogPost4 from '../locales/ja-JP/blogpost4.json';
import jaJPBlogPost5 from '../locales/ja-JP/blogpost5.json';
import jaJPBlogPost6 from '../locales/ja-JP/blogpost6.json';
import jaJPDrawFeature from '../locales/ja-JP/draw.json';
import jaJPAbout from '../locales/ja-JP/about.json';
import jaJPAISuggestions from '../locales/ja-JP/ai-suggestions.json';
import jaJPAccountDeletion from '../locales/ja-JP/account-deletion.json';

import zhCN from '../locales/zh-CN/index.json';
import zhCNTerms from '../locales/zh-CN/terms.json';
import zhCNFaq from '../locales/zh-CN/faq.json';
import zhCNPrivacy from '../locales/zh-CN/privacy.json';
import zhCNAuth from '../locales/zh-CN/auth.json';
import zhCNTopics from '../locales/zh-CN/themes.json';
import zhCNWishlist from '../locales/zh-CN/wishlist.json';
import zhCNAI from '../locales/zh-CN/ai.json';
import zhCNMessages from '../locales/zh-CN/messages.json';
import zhCNBlogPost1 from '../locales/zh-CN/blogpost1.json';
import zhCNBlogPost2 from '../locales/zh-CN/blogpost2.json';
import zhCNBlogPost3 from '../locales/zh-CN/blogpost3.json';
import zhCNBlogPost4 from '../locales/zh-CN/blogpost4.json';
import zhCNBlogPost5 from '../locales/zh-CN/blogpost5.json';
import zhCNBlogPost6 from '../locales/zh-CN/blogpost6.json';
import zhCNDraw from '../locales/zh-CN/draw.json';
import zhCNAbout from '../locales/zh-CN/about.json';
import zhCNAISuggestions from '../locales/zh-CN/ai-suggestions.json';
import zhCNAccountDeletion from '../locales/zh-CN/account-deletion.json';

import koKR from '../locales/ko-KR/index.json';
import koKRTerms from '../locales/ko-KR/terms.json';
import koKRFAQ from '../locales/ko-KR/faq.json';
import koKRPrivacy from '../locales/ko-KR/privacy.json';
import koKRAuth from '../locales/ko-KR/auth.json';
import koKRTopics from '../locales/ko-KR/themes.json';
import koKRWishlist from '../locales/ko-KR/wishlist.json';
import koKRAI from '../locales/ko-KR/ai.json';
import koKRMessages from '../locales/ko-KR/messages.json';
import koKRBlogPost1 from '../locales/ko-KR/blogpost1.json';
import koKRBlogPost2 from '../locales/ko-KR/blogpost2.json';
import koKRBlogPost3 from '../locales/ko-KR/blogpost3.json';
import koKRBlogPost4 from '../locales/ko-KR/blogpost4.json';
import koKRBlogPost5 from '../locales/ko-KR/blogpost5.json';
import koKRBlogPost6 from '../locales/ko-KR/blogpost6.json';
import koKRDraw from '../locales/ko-KR/draw.json';
import koKRAbout from '../locales/ko-KR/about.json';
import koKRAISuggestions from '../locales/ko-KR/ai-suggestions.json';
import koKRAccountDeletion from '../locales/ko-KR/account-deletion.json';

type JSONValue = string | number | boolean | null | JSONObject | JSONArray;
interface JSONObject { [x: string]: JSONValue; }
interface JSONArray extends Array<JSONValue> { }

const translations: Record<LanguageCode, JSONObject> = {
    'pt-BR': {
        ...ptBR,
        terms: ptBRTerms,
        faq: ptBRFaq,
        privacy: ptBRPrivacy,
        auth: ptBRAuth,
        themesFeature: ptBRThemes,
        wishlistFeature: ptBRWishlist,
        aiFeature: ptBRAI,
        messagesFeature: ptBRMessages,
        blogPost1: ptBRBlogPost1,
        blogPost2: ptBRBlogPost2,
        blogPost3: ptBRBlogPost3,
        blogPost4: ptBRBlogPost4,
        blogPost5: ptBRBlogPost5,
        blogPost6: ptBRBlogPost6,
        drawFeature: ptBRDraw,
        about: ptBRAbout,
        aiSuggestions: ptBRAISuggestions,
        accountDeletion: ptBRAccountDeletion
    } as unknown as JSONObject,
    'en-US': {
        ...enUS,
        terms: enUSTerms,
        faq: enUSFaq,
        privacy: enUSPrivacy,
        auth: enUSAuth,
        themesFeature: enUSThemes,
        wishlistFeature: enUSWishlist,
        aiFeature: enUSAI,
        messagesFeature: enUSMessages,
        blogPost1: enUSBlogPost1,
        blogPost2: enUSBlogPost2,
        blogPost3: enUSBlogPost3,
        blogPost4: enUSBlogPost4,
        blogPost5: enUSBlogPost5,
        blogPost6: enUSBlogPost6,
        drawFeature: enUSDraw,
        about: enUSAbout,
        aiSuggestions: enUSAISuggestions,
        accountDeletion: enUSAccountDeletion
    } as unknown as JSONObject,
    'es-ES': {
        ...esES,
        terms: esESTerms,
        faq: esESFaq,
        privacy: esESPrivacy,
        auth: esESAuth,
        themesFeature: esESThemes,
        wishlistFeature: esESWishlist,
        aiFeature: esESAIFeature,
        messagesFeature: esESMessagesFeature,
        blogPost1: esESBlogPost1,
        blogPost2: esESBlogPost2,
        blogPost3: esESBlogPost3,
        blogPost4: esESBlogPost4,
        blogPost5: esESBlogPost5,
        blogPost6: esESBlogPost6,
        drawFeature: esESDrawFeature,
        about: esESAbout,
        aiSuggestions: esESAISuggestions,
        accountDeletion: esESAccountDeletion
    } as unknown as JSONObject,
    'fr-FR': {
        ...frFR,
        terms: frFRTerms,
        faq: frFRFaq,
        privacy: frFRPrivacy,
        auth: frFRAuth,
        themesFeature: frFRTopics,
        wishlistFeature: frFRWishlist,
        aiFeature: frFRAI,
        messagesFeature: frFRMessages,
        blogPost1: frFRBlogPost1,
        blogPost2: frFRBlogPost2,
        blogPost3: frFRBlogPost3,
        blogPost4: frFRBlogPost4,
        blogPost5: frFRBlogPost5,
        blogPost6: frFRBlogPost6,
        drawFeature: frFRDraw,
        about: frFRAbout,
        aiSuggestions: frFRAISuggestions,
        accountDeletion: frFRAccountDeletion
    } as unknown as JSONObject,
    'de-DE': {
        ...deDE,
        terms: deDETerms,
        faq: deDEFaq,
        privacy: deDEPrivacy,
        auth: deDEAuth,
        themesFeature: deDETopics,
        wishlistFeature: deDEWishlist,
        aiFeature: deDEAI,
        messagesFeature: deDEMessages,
        blogPost1: deDEBlogPost1,
        blogPost2: deDEBlogPost2,
        blogPost3: deDEBlogPost3,
        blogPost4: deDEBlogPost4,
        blogPost5: deDEBlogPost5,
        blogPost6: deDEBlogPost6,
        drawFeature: deDEDraw,
        about: deDEAbout,
        aiSuggestions: deDEAISuggestions,
        accountDeletion: deDEAccountDeletion
    } as unknown as JSONObject,
    'it-IT': {
        ...itIT,
        terms: itITTerms,
        faq: itITFaq,
        privacy: itITPrivacy,
        auth: itITAuth,
        themesFeature: itITTopics,
        wishlistFeature: itITWishlist,
        aiFeature: itITAIFeature,
        messagesFeature: itITMessagesFeature,
        blogPost1: itITBlogPost1,
        blogPost2: itITBlogPost2,
        blogPost3: itITBlogPost3,
        blogPost4: itITBlogPost4,
        blogPost5: itITBlogPost5,
        blogPost6: itITBlogPost6,
        drawFeature: itITDrawFeature,
        about: itITAbout,
        aiSuggestions: itITAISuggestions,
        accountDeletion: itITAccountDeletion
    } as unknown as JSONObject,
    'ja-JP': {
        ...jaJP,
        terms: jaJPTerms,
        faq: jaJPFaq,
        privacy: jaJPPrivacy,
        auth: jaJPAuth,
        themesFeature: jaJPTopics,
        wishlistFeature: jaJPWishlist,
        aiFeature: jaJPAIFeature,
        messagesFeature: jaJPMessagesFeature,
        blogPost1: jaJPBlogPost1,
        blogPost2: jaJPBlogPost2,
        blogPost3: jaJPBlogPost3,
        blogPost4: jaJPBlogPost4,
        blogPost5: jaJPBlogPost5,
        blogPost6: jaJPBlogPost6,
        drawFeature: jaJPDrawFeature,
        about: jaJPAbout,
        aiSuggestions: jaJPAISuggestions,
        accountDeletion: jaJPAccountDeletion
    } as unknown as JSONObject,
    'zh-CN': {
        ...zhCN,
        terms: zhCNTerms,
        faq: zhCNFaq,
        privacy: zhCNPrivacy,
        auth: zhCNAuth,
        themesFeature: zhCNTopics,
        wishlistFeature: zhCNWishlist,
        aiFeature: zhCNAI,
        messagesFeature: zhCNMessages,
        blogPost1: zhCNBlogPost1,
        blogPost2: zhCNBlogPost2,
        blogPost3: zhCNBlogPost3,
        blogPost4: zhCNBlogPost4,
        blogPost5: zhCNBlogPost5,
        blogPost6: zhCNBlogPost6,
        drawFeature: zhCNDraw,
        about: zhCNAbout,
        aiSuggestions: zhCNAISuggestions,
        accountDeletion: zhCNAccountDeletion
    } as unknown as JSONObject,
    'ko-KR': {
        ...koKR,
        terms: koKRTerms,
        faq: koKRFAQ,
        privacy: koKRPrivacy,
        auth: koKRAuth,
        themesFeature: koKRTopics,
        wishlistFeature: koKRWishlist,
        aiFeature: koKRAI,
        messagesFeature: koKRMessages,
        blogPost1: koKRBlogPost1,
        blogPost2: koKRBlogPost2,
        blogPost3: koKRBlogPost3,
        blogPost4: koKRBlogPost4,
        blogPost5: koKRBlogPost5,
        blogPost6: koKRBlogPost6,
        drawFeature: koKRDraw,
        about: koKRAbout,
        aiSuggestions: koKRAISuggestions,
        accountDeletion: koKRAccountDeletion
    } as unknown as JSONObject
};

type TranslationKey = string;

export function useTranslation() {
    const [currentLang, setCurrentLang] = useState<LanguageCode>(defaultLanguage);

    useEffect(() => {
        // Detecta o idioma da URL ou do navegador
        const lang = getLanguageFromPath() || detectBrowserLanguage();
        setCurrentLang(lang);
    }, []);

    const t = (key: TranslationKey): string => {
        const keys = key.split('.');
        let value: JSONValue = translations[currentLang];

        for (const k of keys) {
            if (value && typeof value === 'object' && !Array.isArray(value) && k in (value as JSONObject)) {
                value = (value as JSONObject)[k];
            } else {
                value = translations[defaultLanguage];
                for (const fallbackKey of keys) {
                    if (value && typeof value === 'object' && !Array.isArray(value) && fallbackKey in (value as JSONObject)) {
                        value = (value as JSONObject)[fallbackKey];
                    } else {
                        return key;
                    }
                }
                break;
            }
        }

        return typeof value === 'string' ? value : key;
    };

    const tObject = (key: TranslationKey): JSONObject | JSONValue | null => {
        const keys = key.split('.');

        const getByPath = (obj: JSONObject, path: string[]): JSONValue | undefined => {
            let cur: JSONValue = obj;
            for (const k of path) {
                if (cur && typeof cur === 'object' && !Array.isArray(cur) && k in (cur as JSONObject)) {
                    cur = (cur as JSONObject)[k];
                } else {
                    return undefined;
                }
            }
            return cur;
        };

        const deepMerge = (base: JSONValue | undefined, override: JSONValue | undefined): JSONValue | undefined => {
            if (override === undefined) return base;
            if (base === undefined) return override;
            if (typeof base !== 'object' || typeof override !== 'object' || base === null || override === null) {
                return override;
            }
            if (Array.isArray(base) || Array.isArray(override)) {
                return override;
            }
            const result: JSONObject = { ...(base as JSONObject) };
            for (const key of Object.keys(override as JSONObject)) {
                const b = (base as JSONObject)[key];
                const o = (override as JSONObject)[key];
                result[key] = deepMerge(b, o) as JSONValue;
            }
            return result;
        };

        const currentValue = getByPath(translations[currentLang], keys);
        const defaultValue = getByPath(translations[defaultLanguage], keys);

        if (currentValue === undefined && defaultValue === undefined) return null;
        if (currentValue && defaultValue && typeof currentValue === 'object' && typeof defaultValue === 'object' && !Array.isArray(currentValue) && !Array.isArray(defaultValue)) {
            return deepMerge(defaultValue, currentValue) as JSONObject;
        }
        return (currentValue !== undefined ? currentValue : defaultValue) ?? null;
    };

    // Função para traduzir com variáveis
    const tVar = (key: TranslationKey, vars: Record<string, string>): string => {
        let translation = t(key);

        Object.entries(vars).forEach(([varKey, varValue]) => {
            translation = translation.replace(`{${varKey}}`, varValue);
        });

        return translation;
    };

    return { t, tVar, tObject, currentLang };
}
